import { translate } from '@jsverse/transloco';
export enum OrderStatus {
    PROCESSING_PAYMENT = 'PROCESSING_PAYMENT',
    READY_FOR_SCHEDULING = 'READY_FOR_SCHEDULING',
    CANCELLED = 'CANCELLED',
    SCHEDULED = 'SCHEDULED',
    SCHEDULE_CONFIRMED = 'SCHEDULE_CONFIRMED',
    ADDITIONAL_INFO_NEEDED = 'ADDITIONAL_INFO_NEEDED',
    DELIVERY_IN_PROGRESS = 'DELIVERY_IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    DELETED = 'DELETED',
    EXPIRED = 'EXPIRED',
}

export class OrderStatusHelper {
    static getOrderStatusLocale(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.PROCESSING_PAYMENT:
                return translate('ORDER.STATUS.PROCESSING_PAYMENT');
            case OrderStatus.READY_FOR_SCHEDULING:
                return translate('ORDER.STATUS.READY_FOR_SCHEDULING');
            case OrderStatus.CANCELLED:
                return translate('ORDER.STATUS.CANCELED');
            case OrderStatus.SCHEDULED:
                return translate('ORDER.STATUS.SCHEDULED');
            case OrderStatus.SCHEDULE_CONFIRMED:
                return translate('ORDER.STATUS.SCHEDULE_CONFIRMED');
            case OrderStatus.ADDITIONAL_INFO_NEEDED:
                return translate('ORDER.STATUS.ADDITIONAL_INFO_NEEDED');
            case OrderStatus.DELIVERY_IN_PROGRESS:
                return translate('ORDER.STATUS.DELIVERY_IN_PROGRESS');
            case OrderStatus.COMPLETED:
                return translate('ORDER.STATUS.COMPLETED');
            case OrderStatus.DELETED:
                return translate('ORDER.STATUS.DELETED');
            case OrderStatus.EXPIRED:
                return translate('ORDER.STATUS.EXPIRED');
            default:
                return '';
        }
    }

    static getBadgeStatus(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.PROCESSING_PAYMENT:
            case OrderStatus.READY_FOR_SCHEDULING:
                return 'info';
            case OrderStatus.CANCELLED:
            case OrderStatus.DELETED:
                return 'neutral';
            case OrderStatus.SCHEDULED:
            case OrderStatus.ADDITIONAL_INFO_NEEDED:
            case OrderStatus.DELIVERY_IN_PROGRESS:
                return 'warning';
            case OrderStatus.SCHEDULE_CONFIRMED:
            case OrderStatus.COMPLETED:
                return 'success';
            case OrderStatus.EXPIRED:
                return 'error';
            default:
                return 'neutral';
        }
    }
}
